import { Navigate, generatePath } from 'react-router-dom';

import { MLB_SCOUTING_CENTER_STATS } from '@sorare/core/src/constants/__generated__/routes';

const ScoutingCenterPage = () => {
  return <Navigate to={generatePath(MLB_SCOUTING_CENTER_STATS)} />;
};

export default ScoutingCenterPage;
